/**
 * Shared auth types and constants.
 *
 * Deliberately a plain module, not part of the hook: the View needs `AuthStep`
 * and `MIN_PASSWORD_LENGTH` to type its props and build its Zod schema, and Views
 * must not import feature hooks (enforced by the `import/no-restricted-paths`
 * lint rule).
 */

/** Which second factor the signed-in-but-ungated user must clear. */
export type MfaMethod = "email" | "totp";

export type AuthStep =
  | { kind: "form" }
  | { kind: "mfa"; method: MfaMethod; challengeId?: string };

export type AuthMode = "signin" | "register";

/**
 * Backend `MIN_PASSWORD_LENGTH` (`apps/app-api/src/auth/handlers.rs`).
 *
 * A length floor with no composition rules, matching the server's policy — the
 * client must not be stricter, or it rejects passwords the server would accept.
 */
export const MIN_PASSWORD_LENGTH = 12;
